import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ship, ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const DECOR = "https://images.unsplash.com/photo-1706499856012-14f062c72b49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxzaGlwcGluZyUyMGNvbnRhaW5lcnMlMjBzdGFja2VkfGVufDB8fHx8MTc4NjcwMjQyMnww&ixlib=rb-4.1.0&q=85";

export default function ShippingLinesPage() {
  const [lines, setLines] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/shipping-lines").then(({ data }) => setLines(data)); }, []);

  return (
    <Layout>
      <div className="relative bg-navy text-white overflow-hidden">
        <img src={DECOR} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Shipping Lines</h1>
          <p className="text-white/60 mt-2 max-w-2xl">We maintain live ocean freight and local charges across leading global carriers. Every line is priced independently.</p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {lines.map((l) => (
          <div key={l.id} className="border border-border rounded-md p-6 bg-card hover:border-signal transition-colors group" data-testid={`line-card-${l.id}`}>
            <div className="flex items-center justify-between">
              {l.logo_url ? <img src={l.logo_url} alt={l.name} className="h-11 w-11 object-contain rounded-sm border border-border bg-white" /> : <div className="h-11 w-11 bg-navy rounded-sm flex items-center justify-center"><Ship className="h-5 w-5 text-cyan" /></div>}
              <span className="font-mono-data text-xs text-muted-foreground">{l.code}</span>
            </div>
            <h3 className="font-heading font-bold text-xl text-navy mt-4">{l.name}</h3>
            <p className="text-sm text-muted-foreground mt-1">{l.service}</p>
            <p className="text-xs text-muted-foreground mt-3 leading-relaxed">{l.remarks}</p>
            <Button variant="ghost" className="px-0 mt-3 text-signal hover:text-signal hover:bg-transparent" onClick={() => navigate(`/rates?shipment_type=export&shipping_line_id=${l.id}`)}>
              View Rates <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        ))}
      </div>
    </Layout>
  );
}
